export default __webpack_public_path__ + "static/media/single-message.e4d98675.jpg";